import { 
  Dialog, 
  DialogContent, 
  DialogContentText, 
  DialogTitle, 
  IconButton, 
  Divider,
  DialogActions,
  Button
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';

const FeedbackPopUp = ({open, onClose, title, message, type}) => {
  const theme = useTheme();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby='error-title'
      aria-describedby='error-description'
      PaperProps={{ sx: { minWidth: '40em' } }}
    >

      <Divider sx={{ borderColor: type === 'success' ? theme.palette.success.main : theme.palette.error.main, borderWidth: '4.5px' }}/>

      <DialogTitle
        sx={{ fontSize: '16px', fontWeight: '800', textTransform: 'uppercase', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
        id='error-title'
      >
        { title }
        <IconButton
          aria-label='close modal'
          onClick={onClose}
        >
          <CloseIcon style={{ padding: 0 }} />
        </IconButton>
      </DialogTitle>

      <Divider sx={{ marginX: '20px' }}/>

      <DialogContent>
        <DialogContentText id='error-description' sx={{ fontSize: '16px', fontWeight: '400'}}>
          { message }
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="contained" className='button w-2'>
          Ok
        </Button>
      </DialogActions>
      
    </Dialog>
  )
}

FeedbackPopUp.propTypes = {
  open: PropTypes.bool, 
  onClose: PropTypes.func, 
  title: PropTypes.string,
  message: PropTypes.string,
  type: PropTypes.string
}

export default FeedbackPopUp;